export const COUNTRIES = 'https://disease.sh/v3/covid-19/countries';
export const WORLDWIDE_DATA = 'https://disease.sh/v3/covid-19/all';
export const HISTORICAL_ALL = 'https://disease.sh/v3/covid-19/historical/all?lastdays=all';
export const VACCINE_COVERAGE = 'https://disease.sh/v3/covid-19/vaccine/coverage/countries?lastdays=all';